import {
  UseMutationOptions,
  keepPreviousData,
  useMutation,
  useQuery,
} from "@tanstack/react-query"
import { PaginationState } from "@tanstack/react-table"
import type { Prisma } from "@tfg/db"

import { AdminResponses } from "@tfg/types/endpoints/admin"

import { httpClient } from "~/backend/axios"
import { queryClient } from "~/backend/queryClient"

export const useMagicLinkCount = () =>
  useQuery({
    queryKey: ["magicLink"],

    queryFn: async () => {
      const res = await httpClient.get("/admin/magic-link/count")
      return res.data
    },
  })

export const useMagicLinkLogsQuery = (
  fetchDataOptions: PaginationState,
  prismaSorting: Prisma.RefreshTokenOrderByWithRelationInput[] | []
) =>
  useQuery({
    queryKey: ["magicLinkLogs", fetchDataOptions, prismaSorting],

    queryFn: async () => {
      const res = await httpClient.get<AdminResponses.MagicLinkLogs[]>(
        "/admin/magic-link",
        {
          params: {
            fetchDataOptions,
            prismaSorting,
          },
        }
      )
      return res.data
    },

    placeholderData: keepPreviousData,
  })

export const useDeleteMagicLinkMutation = (
  options?: UseMutationOptions<void, unknown, number>
) => {
  return useMutation({
    ...options,
    mutationFn: async (magicLinkId) => {
      return httpClient.delete(`/admin/magic-link/${magicLinkId}`)
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      options?.onSuccess?.(data, variables, onMutateResult, context)
      queryClient.invalidateQueries({ queryKey: ["magicLinkLogs"] })
    },
  })
}
